<div class="position-relative headerBack" id="headerBack" [dir]="this.apiService.currentDirection"
    [ngStyle]="{'text-align': apiService.currentDirection === 'rtl'?'right':'left'}">
    <div class="container" style="min-height: 500px">

        <h3 class="my-5" style="font-weight: bold">{{'DeleteAccountTitle'|translate}}</h3>
        <div class="col-12">
            <p class="py-3" class="text-justify"> {{'DeleteAccountDes'|translate}} </p>
            <h4 class="py-2"> <strong> {{'HowToDeleteAccount'|translate}} </strong></h4>

            <h5> <strong> {{'DeleteZeroOption'|translate}} </strong> </h5>
            <p> {{'DeleteDes0'|translate}} </p>

            <div class="d-flex justify-content-between px-4 m-3">
                <div class="col-12 mt-3 mx-auto border boxShadow contactInfo"
                  [ngStyle]="{'text-align':this.apiService.currentDirection === 'rtl'? 'right':'left'}">
                  <div class="row">
                    <div class="col-12 p-3">
                      <div class="row ">
                        <div class="col-md-6 col-12">
                          <label class="text-black" for="fname">{{'PhoneNum'|translate}} </label>
                          <input type="text" [(ngModel)]="phoneNumber" id="fname" class="form-control rounded-0" placeholder="+1 555 123 4567" required>
                        </div>
                        <div class="col-md-6 col-12">
                          <label class="text-black" for="fname">{{'DeleteAccountReason'|translate}} </label>
                          <select class="form-control rounded-0" [(ngModel)]="status" id="" apperance="outline">
                            <option *ngFor="let item of deleteAccountQues" [value]="item.id">{{item.title}}</option>
                          </select>
                        </div>
                      </div>
                      <div class="row col-12" style="display:contents;">
                        <label class="text-black" for="description"> {{'Message'|translate}}</label>
                        <textarea name="description" [(ngModel)]="message" id="description" cols="30" rows="5"
                          class="form-control rounded-0" placeholder=""></textarea>
                      </div>
                      <div class="d-flex justify-content-end">
                        <button class="btn ptn-primary custom-btn mt-3" (click)="sendReq()"> {{'Send'|translate}} </button>
                      </div>
          
                    </div>
                  </div>
                </div>
              </div>
                <h6> {{'DeleteDes00'|translate}} </h6>

            <br>

            <h5> <strong> {{'DeleteFirstOption'|translate}} </strong> </h5>
            <ol>
                <li>
                    {{'DeleteTitle1'|translate}}
                    <ul> <li> {{'DeleteDes1'|translate}} </li> </ul>
                </li>
                <li>
                    {{'DeleteTitle2'|translate}}
                    <ul> 
                        <li> {{'DeleteDes2'|translate}} </li> 
                        <li> {{'DeleteDes12'|translate}} </li>
                    </ul>
                </li>
                <li>
                    {{'DeleteTitle3'|translate}}
                    <ul> 
                        <li> {{'DeleteDes3'|translate}} </li> 
                        <li> {{'DeleteDes13'|translate}} </li> 
                    </ul>
                </li>
                <li>
                    {{'DeleteTitle4'|translate}}
                    <ul> <li> {{'DeleteDes4'|translate}} </li> </ul>
                </li>
            </ol>
            <br>
            <h5> <strong> {{'DeleteSecondOption'|translate}} </strong> </h5>
            <ol>
                <li>
                    {{'DeleteTitle11'|translate}}
                    <ul> 
                        <li> {{'DeleteDes11'|translate}} </li> 
                        <li> {{'DeleteDes1-2'|translate}} </li> 
                    </ul>
                </li>
                <li>
                    {{'DeleteTitle22'|translate}}
                    <ul> 
                        <li> {{'DeleteDes22'|translate}} </li> 
                    </ul>
                </li>
                <li>
                    {{'DeleteTitle33'|translate}}
                    <ul> 
                        <li> {{'DeleteDes33'|translate}} </li> 
                    </ul>
                </li>
            </ol>
            <br> <br>

            <h5 class="py-2"> <strong> {{'DeleteImportantInfo'|translate}} </strong></h5>
            <ul>
                <li>
                    {{'InfoTitle1'|translate}}
                    <ul> 
                        <li> {{'InfoDes1'|translate}} </li> 
                    </ul>
                </li>
                <li>
                    {{'InfoTitle2'|translate}}
                    <ul> 
                        <li> {{'InfoDes2'|translate}} </li> 
                    </ul>
                </li>
                <li>
                    {{'InfoTitle3'|translate}}
                    <ul> 
                        <li> {{'InfoDes3'|translate}} </li> 
                    </ul>
                </li>
            </ul>
            <br>

            <h5 class="py-2"> <strong> {{'NeedHelp'|translate}} </strong></h5>
            <p> {{'HelpDes'|translate}} </p>
            <br>
            <hr>
            <br>

            <h5 class="py-2"> <strong> {{'FrequentlyAskedQuestions'|translate}} </strong></h5>
            <ol>
                <li>
                    {{'FQ1'|translate}}
                    <p> {{'FQA1'|translate}} </p>
                </li>
                <li>
                    {{'FQ2'|translate}}
                    <p> {{'FQA2'|translate}} </p>
                </li>
                <li>
                    {{'FQ3'|translate}}
                    <p> {{'FQA3'|translate}} </p>
                </li>
            </ol>

            <hr>

            <p class="mb-2"> {{'Address'|translate}} </p>
            <p class="mb-2"> <span> {{'ContactInfo'|translate}} </span> : <span style="direction: ltr;"> +987132318040 </span> </p>
            <p class="mb-2"> <a href="/privacy"> {{'Privacy'|translate}} </a> </p>


            <hr>

            <h5 class="py-2"> <strong> {{'EnsureCompliance'|translate}} </strong></h5>
            <ul>
                <li>
                    {{'EnsureComplianceT1'|translate}}
                    <p> {{'EnsureComplianceD1'|translate}} </p>
                </li>
                <li>
                    {{'EnsureComplianceT2'|translate}}
                    <p> {{'EnsureComplianceD2'|translate}} </p>
                </li>
            </ul>

        </div>
    </div>
</div>